<template>
  <div class="container-fluid px-0">
    <div class="row mb-4 g-2">
      <div class="col-4 col-md-2 col-lg-2">
        <select class="form-select form-select-sm" v-model="genderFilter" @change="handleGenderFilter">
          <option value="">{{ $t('employees.allGenders') }}</option>
          <option value="M">{{ $t('employees.male') }}</option>
          <option value="F">{{ $t('employees.female') }}</option>
        </select>
      </div>

      <div class="col-md-1 d-none d-md-block">
        <button class="btn btn-outline-secondary btn-sm w-100" @click="resetFilters" :title="$t('common.reset')">
          <i class="fas fa-filter-circle-xmark"></i>
        </button>
      </div>

      <div class="col-8 col-md-5 col-lg-5 position-relative">
        <input type="text" class="form-control form-control-sm ps-5" :placeholder="$t('employees.searchPlaceholder')"
               v-model="searchTerm" @input="handleSearch" />
        <span class="position-absolute start-0 top-50 translate-middle-y ps-3">
          <i class="fas fa-search"></i>
        </span>
      </div>

      <div class="col-12 d-md-none">
        <button class="btn btn-outline-secondary btn-sm w-100" @click="resetFilters">
          <i class="fas fa-filter-circle-xmark"></i> {{ $t('common.reset') }}
        </button>
      </div>

      <div class="col-12 col-md-4 col-lg-4">
        <button class="btn btn-secondary btn-sm w-100" @click="$emit('add')" v-can="'employees.create'">
          <i class="fas fa-plus"></i>
          {{ $t('employees.addNew') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import { debounce } from 'lodash';

const searchTerm = ref('');
const genderFilter = ref('');
const emit = defineEmits(['search', 'gender', 'add']);

const handleSearch = debounce(() => emit('search', searchTerm.value), 300);
const handleGenderFilter = () => emit('gender', genderFilter.value);
const resetFilters = () => {
  searchTerm.value = '';
  genderFilter.value = '';
  emit('search', '');
  emit('gender', '');
};
</script>
